const APIv4WishlistResponseAdapter = {
  get: data => {
    const wishlist = data.carts[0];
    return {
      id: wishlist.cart_id,
      userID: wishlist.user_id,
      quantity: wishlist.quantity,
      notificationType: wishlist.notification_type,
      type: wishlist.type,
      currency: wishlist.currency,
      price: wishlist.price,
      state: wishlist.state,
      date: wishlist.date,
      products: APIv4WishlistResponseAdapter.mapProducts(wishlist.products)
    };
  },
  mapProducts: products => {
    return products.map(product => {
      return {
        productID: product.productID,
        quantity: product.quantity,
        price: product.price,
        currency: product.currency
      };
    });
  }
};
export default APIv4WishlistResponseAdapter;
